import angular from 'angular'

import errorHandler from './errorHandler.service'

const name = 'requestsModule'

angular.module(name, [])
  .service('errorHandler', errorHandler)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/requests/requests.module.js